import { SpriteSvg } from '@/components/common/SpriteSvg';

export const Footer = () => {
  return (
    <footer>
      <div className="container">
        <div className="wrapper">
          <div className="menus">
            <a href="https://www.cityheaven.net/tokyo/ACUserToiawase/">お問い合わせ</a>
            <a href="https://www.cityheaven.net/tokyo/sitepolicy/">プライバシーポリシー</a>
          </div>
          <div className="copyright">
            &copy;CityHeaven.net
            <br />
            Powered by{' '}
            <a href="https://knip.jp" className="copyright">
              KNIP
            </a>
          </div>
        </div>
        <SpriteSvg name={'logo-single'} className={'logo'} />
      </div>
    </footer>
  );
};
